export default "__VITE_ASSET__CCHnQbGV__"